import { render, staticRenderFns } from "./PayPalCasesCreation.vue?vue&type=template&id=40119148&scoped=true"
import script from "./PayPalCasesCreation.vue?vue&type=script&lang=js"
export * from "./PayPalCasesCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40119148",
  null
  
)

export default component.exports